import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getUrl } from "../../helpers/url";
import { setShowErrorModal } from "./modalSlice";

const initialState = {
  cardsData: [
    {
      id: 1,
      name: "Free Trial",
      text: "Our free trial includes access to all the premium features.",
      price: "0 $",
      path: "card1",
      points: [
        "15 free syncs",
        "Search companies",
        "Get premium plan features",
      ],
    },
    {
      id: 2,
      name: "Premium",
      text: "Premium plan comes with a fixed cost of:",
      price: "3 $",
      path: "card2",
      points: [
        "Unlimited syncs",
        "0.05 $/sync",
        "Keep your contact records up-to-date",
      ],
    },
  ],
  subscription: {
    loading: false,
    planData: {},
    error: "",
    currentRequestedId: undefined,
  },
};

export const fetchSubscriptionDetails = createAsyncThunk(
  "subscriptions/fetchSubscriptionDetails",
  async (companyId, { dispatch }) => {
    try {
      const { data: response } = await axios.post(
        getUrl("REACT_APP_FIND_CUSTOMER"),
        { companyId }
      );
      return response;
    } catch (error) {
      console.log(error);
      let errorMessage;
      if (error.response && error.response.data.message)
        errorMessage = error.response.data.message;
      else errorMessage = error.message;
      dispatch(setShowErrorModal({ message: errorMessage }));
    }
  }
);

export const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    updatePlanName(state, { payload }) {
      state.subscription.planData.plan = payload.plan;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSubscriptionDetails.pending, (state, action) => {
      if (!state.subscription.loading) {
        state.subscription.loading = true;
      }
    });
    builder.addCase(fetchSubscriptionDetails.fulfilled, (state, action) => {
      if (state.subscription.loading) {
        state.subscription.loading = false;
        state.subscription.planData = action.payload;
        state.subscription.error = "";
      }
    });
    builder.addCase(fetchSubscriptionDetails.rejected, (state, action) => {
      if (state.subscription.loading) {
        state.subscription.loading = false;
        state.subscription.planData = {};
        state.subscription.error = action.error.message ?? "";
      }
    });
  },
});

export const { updatePlanName } = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
